import { LikuMotion } from '../../../store/domain/LikuMotion';
import { queryClient } from '../../../hooks/queries/queryClient';

const PlayerMqtt = (mqtt) => {
	const {
		publish,
		subscribe,
		unsubscribe, // addHandler,
		removeHandler,
	} = mqtt;
	let uuid = null;
	let currentExecutionUuid = null;

	const setUuid = (_uuid) => {
		uuid = _uuid;
	};

	const init = (likuUuid) => {
		setUuid(likuUuid);
	};

	const setContentsConnect = (handler) => {
		const requestedUuid = uuid;
		const requestTime = Date.now();
		console.log('[MetaverseConnect] MQTT subscribe requested', {
			requestedUuid,
			requestTime,
		});
		const display = 'eyekiss';

		const likuMotion = new LikuMotion('greet_arm', display, '연결되었습니다');
		const payload = likuMotion.toPayload();

		subscribe(`liku/${uuid}/json/result`, {
			handlerFunction: function () {
				console.log('[MetaverseConnect] MQTT connection result callback', {
					requestedUuid,
					currentUuid: uuid,
					requestTime,
					elapsedMs: Date.now() - requestTime,
				});
				console.log('setContentsConnect handler', handler);
				if (typeof handler === 'function') {
					handler();
				}
				removeHandler(`liku/${uuid}/json/result`, this.handlerFunction);
			},
			requiredParameter: 'topic',
		});
		console.log('[MetaverseConnect] MQTT connection publish requested', {
			requestedUuid,
			currentUuid: uuid,
			requestTime,
		});
		publish(`liku/${uuid}/json/list`, payload);
	};

	const setContentsMode = (id, executionUuid, handler) => {
		subscribe(`liku/${id}/ackCheck`);
		subscribe(`liku/musical/${executionUuid}/check`);
		subscribe(`liku/musical/${executionUuid}`, {
			handlerFunction: handler,
			requiredParameter: 'both',
		});
	};

	const unsetContentsMode = (id, executionUuid) => {
		unsubscribe(`liku/${id}/ackCheck`);
		unsubscribe(`liku/musical/${executionUuid}/check`);
		unsubscribe(`liku/musical/${executionUuid}`);

		unsubArucoMode();
		unsubTouchMode();
	};

	const isContentsReady = () => {
		publish(`liku/${uuid}/musical/ready`, '?');
	};

	const contentsCheck = (executionUuid, contentsUuid) => {
		publish(`liku/musical/${executionUuid}/check`, { contentsUuid });
	};

	const setArucoMode = (data, handler) => {
		let payload = null;
		if (data) payload = { ...data };
		else payload = 'stop';

		console.log('isAruco data', data);
		console.log('isAruco , handler', handler);
		if (handler) {
			// Prevent duplicate callback execution when re-entering loop nodes.
			removeHandler(`liku/${uuid}/aruco/result`, handler);
			subscribe(`liku/${uuid}/aruco/result`, {
				handlerFunction: handler,
				requiredParameter: 'payload',
			});
		}
		publish(`liku/${uuid}/robot/aruco`, payload);
	};
	const unsubArucoMode = () => {
		unsubscribe(`liku/${uuid}/robot/aruco`);
	};

	const setTouchMode = (data, handler) => {
		let payload = { touch_mode: true };
		if (typeof data === 'object' && data !== null) {
			payload = data;
		} else if (
			data === false ||
			data === 'stop' ||
			data === 'false' ||
			data === 0
		) {
			payload = { touch_mode: false };
		}

		if (handler) {
			// Prevent duplicate callback execution when re-entering loop nodes.
			removeHandler(`liku/${uuid}/aruco/touch_mode/result`, handler);
			subscribe(`liku/${uuid}/aruco/touch_mode/result`, {
				handlerFunction: handler,
				requiredParameter: 'payload',
			});
		}
		publish(`liku/${uuid}/robot/aruco/touch_mode`, payload);
	};

	const unsubTouchMode = () => {
		publish(`liku/${uuid}/robot/aruco/touch_mode`, { touch_mode: false });
		unsubscribe(`liku/${uuid}/aruco/touch_mode/result`);
	};

	const setFacePhotos = (facePhotosHandler, wholePhotosHandler) => {
		subscribe(`liku/${uuid}/vis/image/database`, {
			handlerFunction: (...args) => {
				facePhotosHandler(...args);
				queryClient.invalidateQueries(['liku-face-memorty']);
			},
		});
		subscribe(`liku/${uuid}/vis/image/metaverse/whole`, {
			handlerFunction: wholePhotosHandler,
			requiredParameter: 'originPayload',
		});
	};

	/**
	 * Set photo request state.
	 * @message {string} photoType
	 *   - 'memory': existing memory photos
	 *   - 'new': capture new photo
	 */
	const requestFacePhoto = (message) => {
		publish(`liku/${uuid}/vis/image/metaverse`, message);
	};

	const unsetFacePhotos = () => {
		unsubscribe(`liku/${uuid}/vis/image/database`);
		unsubscribe(`liku/${uuid}/vis/image/metaverse/whole`);
	};

	// const responsesFacePhotoDB = (handler) => {
	// 	subscribe(`liku/${uuid}/vis/image/database`, {
	// 		handlerFunction: handler,
	// 		// requiredParameter: 'both',
	// 	});
	// };
	//
	// const responsesWholePhoto = () => {};

	// ------------------metaverse
	const metaverseImageDB = async (handler) => {
		subscribe(`liku/${uuid}/vis/image/database`, {
			handlerFunction: handler,
			requiredParameter: 'both',
		});
	};

	// const metaverseWhole = async (handler) => {
	// 	subscribe(`liku/${uuid}/vis/image/metaverse/whole`, {
	// 		handlerFunction: handler,
	// 		requiredParameter: 'both',
	// 	});
	// };

	const metaverseImageUser = async (handler) => {
		subscribe(`liku/${uuid}/vision/image/user`, {
			handlerFunction: handler,
			requiredParameter: 'both',
		});
	};

	const unsetMetaverse = () => {
		unsubscribe(`liku/${uuid}/vis/image/database`);
		unsubscribe(`liku/${uuid}/vis/image/metaverse/whole`);
		unsubscribe(`liku/${uuid}/vision/image/user`);
	};
	// ------------------metaverse

	const musicalSet = async (sessionUuid, likuSerial) => {
		currentExecutionUuid = sessionUuid;
		const topic = `liku/${uuid}/musical/set`;
		const msg = { uuid: sessionUuid, role: likuSerial };
		await publish(topic, msg);
	};

	const setListenText = (handler) => {
		// interactive contents listen subscribe
		subscribe(`liku/${uuid}/json/transcript`, {
			handlerFunction: handler,
			requiredParameter: 'payload',
		});
		// { handlerFunction: handler });
	};

	const unsetListenText = () => {
		subscribe(`liku/${uuid}/json/transcript`);
	};

	const playMotion = (executionUuid, role, data) => {
		publish(`liku/musical/${executionUuid}/${role}`, data);
	};

	const defaultStop = () => {
		publish(`liku/${uuid}/user/stop`, 'stop');
	};

	const musicalStop = (payload) => {
		if (payload === currentExecutionUuid) currentExecutionUuid = null;
		publish(`liku/${uuid}/musical/stop`, payload);
	};

	const stopCurrentContent = () => {
		defaultStop();

		if (currentExecutionUuid) {
			musicalStop(currentExecutionUuid);
		}
	};

	return {
		init,
		setContentsConnect,
		setContentsMode,
		unsetContentsMode,
		isContentsReady,
		contentsCheck,

		setArucoMode,
		unsubArucoMode,

		setTouchMode,
		unsubTouchMode,

		setFacePhotos,
		requestFacePhoto,
		unsetFacePhotos,

		metaverseImageDB, // metaverseWhole,
		metaverseImageUser,
		unsetMetaverse,

		setListenText,
		unsetListenText,

		playMotion,
		musicalSet,

		defaultStop,
		musicalStop,
		stopCurrentContent,
	};
};

export default PlayerMqtt;
